import { FlaskConical } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { FormulationsPage } from './pages/FormulationsPage'

/**
 * Formulations — Active Formulas (Sprint 08 narrow v1).
 *
 * Core Excel replacement: formulas live in the ops DB (SPI IP, never
 * Odoo). MasterDetail list + EditableGrid editor + ProductPicker on
 * ingredient rows. %-totals validation (sum ≤ 100%) + batch-scaled
 * target weights. Import existing workbooks via the toolbar button →
 * POST /api/formulations/import-template.
 *
 * Middleware endpoints land under `/api/formulations/*` — see
 * docs/active/sprint-08-formulations-active-formulas.md.
 *
 * RBAC: visibility gated to admin + regulatory + operations. Regulatory
 * owns edits (IP + compliance); operations reads for production
 * context. Other roles don't see the module.
 */
export default defineModule({
  id: 'formulations',
  name: 'Formulations',
  shortName: 'Formulas',
  icon: FlaskConical,
  navSection: 'formulations',
  navOrder: 10,
  urlNamespace: '/formulations',
  routes: [{ path: '/', element: FormulationsPage, label: 'Formulations' }],
  permissions: ['admin', 'regulatory', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  // `g f` was already bound by fulfillment-risk. `g r` (foRmulations /
  // Recipes) is the cleanest open mnemonic.
  keyboardShortcut: 'g r',

  commandPaletteEntries: [
    {
      label: 'Go to Formulations',
      keywords: [
        'formulation',
        'formulations',
        'formula',
        'recipe',
        'ingredients',
        'active formulas',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g r',
    },
  ],

  consumesServices: ['odoo-search'],
})
